import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BoardGrid from "../components/BoardGrid";
import { CODES } from "../data/codebook";

export default function Home() {
  const { t } = useTranslation();

  // Show a demo sentence on the home page — pick the first code.
  const demo = CODES[0];

  return (
    <div className="hero">
      <div>
        <img src="/logo.svg" alt="LEXIKON" style={{ width: "min(360px, 70%)", marginBottom: 16 }} />
        <p className="lede">{t("home.lede")}</p>
        <div className="cta-row">
          <Link to="/solo" className="btn primary">{t("home.soloCta")} →</Link>
          <Link to="/play" className="btn ghost">{t("home.playCta")}</Link>
        </div>
      </div>
      <div>
        <div style={{ transform: "scale(0.78)", transformOrigin: "top right" }}>
          <BoardGrid tokens={demo.tokens} />
        </div>
      </div>
    </div>
  );
}
